import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propFunc, propStr, propChildren, } from '../../../../helpers/custom-prop-types';
import LogoIcon from '../../../Icon/Svg/LogoIcon';
import HtmlLink from '../../../Ui/Common/HtmlLink';
import Hover from '../../../Ui/System/Hover';
/**
 * 会員状況に応じたProffitへの導線を表示するコンポーネント
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
const SlideSearchHeaderActionButton = (props) => {
    const { className, isNoLinkComponent, onClickNoLink, textComponent, to } = props;
    return (_jsx(Hover, { children: _jsxs(HtmlLink, Object.assign({ className: clsx('slide_search_header_action_button button', className), isNoLinkComponent: isNoLinkComponent, onClickNoLink: onClickNoLink, to: to }, { children: [_jsx("span", Object.assign({ className: 'button_icon' }, { children: _jsx(LogoIcon, { className: 'icon_svg' }) })), _jsx("span", Object.assign({ className: 'button_text' }, { children: textComponent }))] })) }));
};
SlideSearchHeaderActionButton.propTypes = {
    className: propStr(),
    isNoLinkComponent: propStr(),
    onClickNoLink: propFunc(),
    textComponent: propChildren().isRequired,
    to: propStr().isRequired,
};
SlideSearchHeaderActionButton.defaultProps = {
    className: '',
    isNoLinkComponent: undefined,
    onClickNoLink: undefined,
};
export default SlideSearchHeaderActionButton;
